
import Navigation from "@/components/Navigation";

interface LoadingStateProps {
  debugInfo: string;
}

const LoadingState = ({ debugInfo }: LoadingStateProps) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Navigation />
      <div className="py-8 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center">
            <div className="text-lg mb-2">Loading investment opportunities...</div>
            <div className="text-sm text-gray-600">Please wait while we fetch the latest data</div>
            {debugInfo && (
              <div className="mt-4 p-4 bg-blue-100 rounded-lg">
                <p className="text-sm text-blue-800">Debug: {debugInfo}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingState;
